import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function PurchaseSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m23.017,8.785c-.595-.542-1.364-.816-2.168-.782-.804.038-1.544.387-2.086.981l-3.216,3.534c-.551-.909-1.55-1.519-2.689-1.519H4c-2.206,0-4,1.794-4,4v5c0,2.206,1.794,4,4,4h4.965c2.849,0,5.57-1.22,7.466-3.348l6.805-7.638c1.093-1.227.994-3.124-.219-4.229Zm-1.274,2.899l-6.805,7.638c-1.517,1.701-3.694,2.678-5.973,2.678h-4.965c-1.103,0-2-.897-2-2v-5c0-1.103.897-2,2-2h8.858c.63,0,1.142.513,1.142,1.143,0,.564-.421,1.051-.981,1.13l-5.161.737c-.546.078-.926.585-.848,1.132.079.548.585.929,1.131.849l5.16-.737c1.175-.168,2.13-.988,2.515-2.059l4.426-4.864c.182-.199.43-.316.7-.329.274-.016.528.081.728.263.407.371.44,1.009.073,1.421ZM4.294,4.494c-.267-.226-.364-.594-.243-.922.12-.328.433-.546.782-.546h2.501l.885-2.483c.121-.326.433-.542.781-.542s.66.216.781.542l.885,2.483h2.501c.35,0,.663.219.783.548.12.329.022.698-.246.923l-1.971,1.606.815,2.484c.112.336-.002.706-.282.922-.281.216-.667.231-.964.038l-2.295-1.495-2.257,1.51c-.14.094-.302.141-.463.141-.176,0-.352-.056-.5-.166-.283-.212-.401-.58-.295-.917l.784-2.513-1.981-1.612Z"
        />
      </svg>
    </Box>
  );
}
